/* eslint-disable no-shadow */

export enum USER_ROLES {
  'ADMIN',
  'CAMPAIGN_EDITOR',
  'PRODUCT_MANAGER',
  'CONTENT_EDITOR',
}

export enum PERMISSIONS {
  'campaigns',
  'users',
  'base',
  'products',
  'publishers',
  'categories',
  'affiliateNetworks',
  'brands',
  'import',
  'websites',
  'merchants',
  'inventory',
  'createProduct',
  'createDeeplink',
  'registerProduct',
  'linkGenerator',
  'createDealDeeplink',
  'manageMerchantDomains',
}

export type RoleType = keyof typeof USER_ROLES;

export type PermissionType = keyof typeof PERMISSIONS;

type PermissionAttr = {
  [permission in PermissionType]: boolean | PermissionAttr;
};

type PermissionMap = {
  [role in RoleType]: PermissionAttr;
};

const allPermissions = Object.keys(PERMISSIONS).reduce((all: any, a) => {
  Object.assign(all, {
    [a]: true,
  });
  return all;
}, {});

const PERMISSIONS_MAP = {
  ADMIN: allPermissions,
  CAMPAIGN_EDITOR: {
    ...allPermissions,
    users: false,
    publishers: false,
    websites: false,
    merchants: false,
    products: false,
    affiliateNetworks: false,
    manageMerchantDomains: false,
  },
  PRODUCT_MANAGER: {
    ...allPermissions,
    campaigns: false,
    users: false,
    publishers: false,
    websites: false,
    manageMerchantDomains: false,
  },
  CONTENT_EDITOR: {
    ...allPermissions,
    campaigns: false,
    users: false,
    publishers: false,
    websites: false,
    manageMerchantDomains: false,
  },
} as PermissionMap;

const findDeepKeys = (o: PermissionAttr): PermissionType[] => {
  let result: PermissionType[] = [];
  Object.keys(o).forEach((k) => {
    const p = k as unknown as PermissionType;
    if (o[p] === true) {
      result.push(p);
    }
    if (o[p] !== false) {
      result.push(p);
      const oAsPermissionAttr = o[p] as PermissionAttr;
      const subresults = findDeepKeys(oAsPermissionAttr);
      result = [...result, ...subresults];
    }
  });
  return result;
};

export default class SecurityService {
  public static isPermitted(role: RoleType, ...permissionsToCheck: PermissionType[]): boolean {
    if (!role || !permissionsToCheck) {
      return true;
    }
    const map = PERMISSIONS_MAP[role];
    const keys = findDeepKeys(map);
    const indexPermission = permissionsToCheck.findIndex((check) => keys.includes(check));
    return indexPermission > -1;
  }
}
